export const WORDS = [
  "addio",
  "adipe",
  "vizio",
  "donna",
  "calco",
  "fungo",
  "estro",
  "dildo",
  "ritmo",
  "faida",
  "sagra",
  "brina",
  "fusto",
  "terno",
  "sisma",
  "oppio",
  "pompa",
  "cuore",
  "amaro",
  "iodio",
  "eremo",
  "sigla",
  "polpo",
  "feudo",
  "tempo",
  "umore",
  "prole",
  "norma",
  "tetta",
  "vuoto",
  "talco",
  "treno",
  "ponte",
  "dorso",
  "mallo",
  "pasta",
  "tatto",
  "sacco",
  "arnia",
  "mozzo",
  "tosse",
  "iride",
  "album",
  "firma",
  "salto",
  "pezzo",
  "molla",
  "fitta",
  "mondo",
  "aroma",
  "clima",
  "fossa",
  "madre",
  "golpe",
  "tasca",
  "mafia",
  "atrio",
  "peone",
  "aglio",
  "palmo",
  "apice",
  "monte",
  "tocco",
  "zizza",
  "cuoio",
  "valle",
  "sodio",
  "conto",
  "ghiro",
  "agave",
  "fibra",
  "malta",
  "poeta",
  "cella",
  "milza",
  "passo",
  "alibi",
  "salma",
  "forma",
  "sella",
  "fuoco",
  "folla",
  "regno",
  "cardo",
  "bruma",
  "koala",
  "culla",
  "ovile",
  "becco",
  "sansa",
  "fatto",
  "gotta",
  "barca",
  "carta",
  "crine",
  "avaro",
  "colpa",
  "plebe",
  "gemma",
  "sesso",
  "piuma",
  "liuto",
  "mambo",
  "tomba",
  "frate",
  "crema",
  "zuppa",
  "uscio",
  "morsa",
  "bisca",
  "masso",
  "esodo",
  "corda",
  "anima",
  "scusa",
  "alano",
  "gatto",
  "copia",
  "paura",
  "gamma",
  "abete",
  "menta",
  "giara",
  "magia",
  "usura",
  "ronda",
  "parco",
  "guida",
  "rumba",
  "tigna",
  "porta",
  "osare",
  "corna",
  "viale",
  "capro",
  "isola",
  "astro",
  "zolla",
  "ferro",
  "bacio",
  "baita",
  "cargo",
  "grano",
  "botto",
  "obice",
  "rutto",
  "baffo",
  "tonfo",
  "notte",
  "pesca",
  "tuono",
  "berta",
  "dazio",
  "gallo",
  "vodka",
  "sidro",
  "razza",
  "antro",
  "lutto",
  "daino",
  "radio",
  "cavia",
  "festa",
  "palma",
  "lotto",
  "gesso",
  "cacao",
  "bolla",
  "curva",
  "multa",
  "sarda",
  "marea",
  "muffa",
  "fondo",
  "porto",
  "pizzo",
  "perla",
  "puffo",
  "scala",
  "sfiga",
  "piaga",
  "mirra",
  "oliva",
  "riffa",
  "poema",
  "ratto",
  "parte",
  "carpa",
  "alveo",
  "senso",
  "fresa",
  "globo",
  "edile",
  "turca",
  "tordo",
  "trave",
  "ostro",
  "polso",
  "ladro",
  "frode",
  "cielo",
  "asola",
  "acqua",
  "benda",
  "tasso",
  "bocca",
  "vezzo",
  "gnomo",
  "anodo",
  "acero",
  "pugno",
  "danza",
  "verro",
  "remix",
  "ovest",
  "tetto",
  "nerbo",
  "calza",
  "danno",
  "pollo",
  "pappa",
  "disco",
  "volpe",
  "suola",
  "piega",
  "piego",
  "serpe",
  "vello",
  "cervo",
  "torba",
  "zaino",
  "detto",
  "varco",
  "villa",
  "anice",
  "cacio",
  "lager",
  "babbo",
  "tinta",
  "acaro",
  "mirto",
  "leone",
  "acume",
  "boato",
  "teppa",
  "video",
  "brodo",
  "birra",
  "fauna",
  "abate",
  "bando",
  "mutuo",
  "vocio",
  "suora",
  "pausa",
  "zampa",
  "drago",
  "tappa",
  "uggia",
  "agire",
  "pazzo",
  "randa",
  "bazar",
  "bidet",
  "bambu",
  "icona",
  "pippa",
  "patta",
  "carme",
  "podio",
  "campo",
  "peana",
  "vulva",
  "boria",
  "lotta",
  "cassa",
  "acido",
  "cocco",
  "micio",
  "poppa",
  "cicca",
  "arabo",
  "credo",
  "ruota",
  "rotta",
  "nesso",
  "cappa",
  "farsa",
  "rombo",
  "frana",
  "gazza",
  "amare",
  "dieta",
  "ponfo",
  "badia",
  "balzo",
  "beuta",
  "prete",
  "upupa",
  "merlo",
  "nanna",
  "tacca",
  "faina",
  "ballo",
  "ceppo",
  "nafta",
  "cloro",
  "manto",
  "nylon",
  "dotto",
  "zinco",
  "bordo",
  "miele",
  "alice",
  "ascia",
  "corpo",
  "vigna",
  "delta",
  "azoto",
  "nonno",
  "bonta",
  "cetra",
  "arare",
  "avena",
  "esame",
  "gambo",
  "zappa",
  "udito",
  "pizza",
  "ameba",
  "amaca",
  "sasso",
  "garza",
  "banca",
  "fiato",
  "cacca",
  "prosa",
  "vampa",
  "piede",
  "jolly",
  "erede",
  "cesta",
  "segno",
  "lacca",
  "scavo",
  "bullo",
  "odore",
  "ovaia",
  "tasto",
  "ebano",
  "picco",
  "lisca",
  "poker",
  "obolo",
  "purga",
  "amido",
  "tibia",
  "gioco",
  "costo",
  "carro",
  "tanga",
  "ogiva",
  "terna",
  "vespa",
  "petto",
  "limbo",
  "zombi",
  "padre",
  "ombra",
  "genio",
  "tazza",
  "patto",
  "palco",
  "massa",
  "latte",
  "pacco",
  "calca",
  "motto",
  "wafer",
  "tarlo",
  "bimbo",
  "aiuto",
  "idolo",
  "animo",
  "risma",
  "cazzo",
  "fango",
  "busta",
  "nocca",
  "manzo",
  "kayak",
  "merda",
  "omero",
  "perno",
  "canna",
  "fiera",
  "pegno",
  "zecca",
  "golfo",
  "casta",
  "banco",
  "mazza",
  "etica",
  "zuffa",
  "pista",
  "scalo",
  "cigno",
  "ninfa",
  "verbo",
  "basso",
  "dente",
  "prato",
  "posta",
  "paese",
  "scout",
  "terzo",
  "torta",
  "posto",
  "panca",
  "bozza",
  "clone",
  "pesce",
  "asilo",
  "ceffo",
  "corvo",
  "bugna",
  "cieco",
  "borsa",
  "tedio",
  "coppo",
  "gamba",
  "reame",
  "oscar",
  "dardo",
  "manna",
  "pinna",
  "circo",
  "sfera",
  "istmo",
  "botta",
  "cobra",
  "abito",
  "nervo",
  "emiro",
  "salmo",
  "rugby",
  "piena",
  "ulivo",
  "lista",
  "dolce",
  "melma",
  "posse",
  "lembo",
  "brama",
  "ansia",
  "lenza",
  "zucca",
  "ozono",
  "porco",
  "lemma",
  "sogno",
  "scena",
  "samba",
  "atomo",
  "preda",
  "ragno",
  "salva",
  "bardo",
  "lampo",
  "forno",
  "torre",
  "viola",
  "beffa",
  "zolfo",
  "buono",
  "lusso",
  "retto",
  "messa",
  "felce",
  "snack",
  "mazzo",
  "vitto",
  "falla",
  "orata",
  "oblio",
  "scafo",
  "abaco",
  "balsa",
  "ressa",
  "tonno",
  "cesso",
  "prova",
  "costa",
  "cuoco",
  "trend",
  "letto",
  "finta",
  "corso",
  "vista",
  "pinta",
  "morte",
  "guado",
  "canto",
  "morra",
  "soldo",
  "epoca",
  "retta",
  "coppa",
  "duomo",
  "adire",
  "trama",
  "nembo",
  "nuora",
  "falda",
  "zebra",
  "rampa",
  "talpa",
  "lobby",
  "carne",
  "senno",
  "collo",
  "clava",
  "urina",
  "panna",
  "tappo",
  "pozza",
  "hotel",
  "tenda",
  "bieta",
  "extra",
  "cenno",
  "serra",
  "putto",
  "turno",
  "cuneo",
  "aureo",
  "socio",
  "gergo",
  "ghisa",
  "mensa",
  "ruspa",
  "mucca",
  "rocca",
  "ancia",
  "tizio",
  "calce",
  "presa",
  "cozza",
  "bagno",
  "asino",
  "party",
  "robot",
  "conte",
  "porno",
  "elica",
  "vetro",
  "servo",
  "cosca",
  "penna",
  "cozzo",
  "barba",
  "manga",
  "piano",
  "furia",
  "gesta",
  "polca",
  "gobbo",
  "palio",
  "dandy",
  "droga",
  "guaio",
  "falco",
  "opale",
  "malto",
  "ovulo",
  "tassa",
  "mamma",
  "ostia",
  "renna",
  "freno",
  "adito",
  "tigre",
  "sedia",
  "testo",
  "fallo",
  "cruna",
  "borgo",
  "pesto",
  "ugola",
  "picca",
  "tacco",
  "pigna",
  "callo",
  "peste",
  "nozze",
  "orafo",
  "siepe",
  "dogma",
  "bravo",
  "morso",
  "agone",
  "palla",
  "raffa",
  "lardo",
  "amico",
  "gesto",
  "gusto",
  "ambra",
  "yuppy",
  "alcol",
  "edera",
  "mango",
  "blusa",
  "siero",
  "fieno",
  "amore",
  "farro",
  "aereo",
  "mosto",
  "panda",
  "marmo",
  "linfa",
  "brano",
  "vento",
  "terra",
  "totem",
  "lepre",
  "tarma",
  "flora",
  "sfida",
  "capra",
  "onere",
  "torto",
  "cirro",
  "toppa",
  "barra",
  "zeppa",
  "aceto",
  "motel",
  "borra",
  "liceo",
  "venia",
  "beato",
  "grido",
  "puzza",
  "forza",
  "canoa",
  "umano",
  "carie",
  "colle",
  "coito",
  "conca",
  "scopa",
  "abuso",
  "fosso",
  "vetta",
  "verme",
  "crepa",
  "mezzo",
  "vasca",
  "fante",
  "bruco",
  "astio",
  "cedro",
  "corsa",
  "alito",
  "legno",
  "porro",
  "metro",
  "elite",
  "mania",
  "banda",
  "furto",
  "culto",
  "parto",
  "punta",
  "punto",
  "fetta",
  "colla",
  "baule",
  "vacca",
  "vallo",
  "valva",
  "vanga",
  "vanto",
  "visto",
  "vinto",
  "bivio",
  "caffe",
  "cameo",
  "causa",
  "cecio",
  "cesto",
  "mappa",
  "marco",
  "ruolo",
  "rullo",
  "reato",
  "radar",
  "reuma",
  "rissa",
  "rione",
  "ridda",
  "resto",
  "rondo",
  "ronza",
  "rublo",
  "rospo",
  "rogna",
  "acheo",
  "acino",
  "adone",
  "afnio",
  "aggio",
  "agape",
  "agora",
  "alone",
  "amato",
  "angue",
  "aorta",
  "arena",
  "argon",
  "aridi",
  "arpia",
  "avere",
  "avvio",
  "bacca",
  "balia",
  "balio",
  "balla",
  "balza",
  "banjo",
  "banno",
  "bario",
  "barro",
  "basco",
  "basto",
  "batto",
  "bazza",
  "becca",
  "belga",
  "belva",
  "belta",
  "betta",
  "bezzo",
  "biada",
  "bigne",
  "bingo",
  "bitta",
  "bizza",
  "blitz",
  "blues",
  "boemo",
  "boero",
  "bollo",
  "bomba",
  "bombo",
  "bongo",
  "borda",
  "bosco",
  "botte",
  "boxer",
  "bozzo",
  "braca",
  "brace",
  "breve",
  "briga",
  "broda",
  "bromo",
  "bruno",
  "bruto",
  "buffa",
  "buffo",
  "bugia",
  "bugno",
  "bulbo",
  "burla",
  "burro",
  "busso",
  "busto",
  "butta",
  "buzzo",
  "cachi",
  "cagna",
  "caldo",
  "calma",
  "camma",
  "canea",
  "carre",
  "casba",
  "casco",
  "cavea",
  "cazza",
  "celia",
  "censo",
  "cento",
  "cerio",
  "cerna",
  "cerro",
  "cesio",
  "chela",
  "chilo",
  "chimo",
  "china",
  "ciclo",
  "cifra",
  "cinta",
  "cinto",
  "cippo",
  "cispa",
  "ciste",
  "cisti",
  "cisto",
  "citta",
  "ciuco",
  "clero",
  "clown",
  "coala",
  "coati",
  "coffa",
  "colmo",
  "colpo",
  "colon",
  "colza",
  "comma",
  "conga",
  "conta",
  "copto",
  "corno",
  "corte",
  "cosmo",
  "cotta",
  "cotto",
  "crasi",
  "creso",
  "creta",
  "crino",
  "crisi",
  "croce",
  "croco",
  "croda",
  "crodo",
  "croma",
  "cromo",
  "cross",
  "crudo",
  "cubia",
  "cucco",
  "cuccu",
  "culmo",
  "cumis",
  "cunta",
  "curdo",
  "curia",
  "curio",
  "curro",
  "curry",
  "cusco",
  "cusso",
  "cuvee",
  "dacia",
  "dafne",
  "dalia",
  "damma",
  "danda",
  "daspo",
  "deita",
  "denim",
  "derby",
  "derma",
  "desco",
  "diade",
  "diana",
  "dicco",
  "dieci",
  "diene",
  "diesi",
  "dindo",
  "dingo",
  "diodo",
  "diolo",
  "ditta",
  "dobla",
  "dolio",
  "dolly",
  "dosso",
  "draba",
  "draga",
  "dreno",
  "drink",
  "droma",
  "dromo",
  "drone",
  "drudo",
  "drupa",
  "drusa",
  "druso",
  "ducea",
  "duina",
  "duino",
  "duolo",
  "duplo",
  "duvet",
  "ebbio",
  "ebere",
  "ebete",
  "ebola",
  "ebreo",
  "ebulo",
  "echio",
  "edema",
  "efebo",
  "eforo",
  "egida",
  "egira",
  "elafe",
  "elice",
  "eliea",
  "eliso",
  "elson",
  "emero",
  "emide",
  "emolo",
  "emulo",
  "enula",
  "epodo",
  "erbio",
  "erebo",
  "erica",
  "ernia",
  "eruca",
  "esano",
  "esipo",
  "esito",
  "esone",
  "essai",
  "esule",
  "etano",
  "etene",
  "etera",
  "etere",
  "etero",
  "ethos",
  "etile",
  "etimo",
  "etnia",
  "evaso",
  "fabro",
  "falca",
  "falce",
  "falso",
  "fanga",
  "farad",
  "fardo",
  "farea",
  "fasto",
  "fatta",
  "fatwa",
  "fauce",
  "fauci",
  "fauno",
  "feace",
  "felpa",
  "felze",
  "feria",
  "ferie",
  "ferma",
  "fermo",
  "fersa",
  "ferza",
  "ferzo",
  "fessa",
  "fesso",
  "fiaba",
  "fiala",
  "fiano",
  "fiata",
  "fiche",
  "ficco",
  "ficus",
  "fiele",
  "filet",
  "filza",
  "finca",
  "fiore",
  "fisco",
  "fissa",
  "fiume",
  "fiuto",
  "flano",
  "flash",
  "flato",
  "flebo",
  "fleto",
  "flirt",
  "flute",
  "fobia",
  "focus",
  "fodro",
  "fogna",
  "foiba",
  "folle",
  "fonda",
  "fonia",
  "fonte",
  "forca",
  "force",
  "forci",
  "forra",
  "forte",
  "forum",
  "fotta",
  "fovea",
  "foyer",
  "fraga",
  "frase",
  "freak",
  "frega",
  "frigo",
  "frine",
  "frodo",
  "fuffa",
  "fumea",
  "funky",
  "futon",
  "gabba",
  "gabbo",
  "gaffa",
  "gaffe",
  "galea",
  "galla",
  "galop",
  "gamia",
  "ganda",
  "ganga",
  "gassa",
  "ganzo",
  "garbo",
  "garni",
  "garzo",
  "gauss",
  "gelso",
  "genia",
  "genoa",
  "gente",
  "geode",
  "gerba",
  "gerla",
  "gerlo",
  "germa",
  "germe",
  "getto",
  "ghebi",
  "ghebo",
  "ghego",
  "giaco",
  "giada",
  "gibbo",
  "gilda",
  "giogo",
  "gioia",
  "girlo",
  "gleba",
  "glena",
  "glifo",
  "glomo",
  "gluma",
  "gnosi",
  "gobba",
  "gogna",
  "golem",
  "gombo",
  "gomma",
  "gonna",
  "gonzo",
  "gorgo",
  "gotha",
  "gotto",
  "gozzo",
  "grada",
  "grado",
  "grafo",
  "grana",
  "grata",
  "grave",
  "greca",
  "greco",
  "greto",
  "grico",
  "grida",
  "grifo",
  "grill",
  "grola",
  "groma",
  "gruma",
  "grumo",
  "guaco",
  "guano",
  "guato",
  "guisa",
  "gulag",
  "gurge",
  "gurgi",
  "gusla",
  "gutto",
  "haiku",
  "harem",
  "henne",
  "hertz",
  "hippy",
  "hobby",
  "humus",
  "husky",
  "iarda",
  "ibero",
  "ibice",
  "icore",
  "ictus",
  "iddia",
  "iddio",
  "idria",
  "iella",
  "igloo",
  "ilice",
  "ilota",
  "image",
  "imano",
  "imene",
  "indio",
  "indri",
  "inuit",
  "inula",
  "invio",
  "ioide",
  "iolla",
  "ionio",
  "ipate",
  "ipato",
  "irbis",
  "ireos",
  "irite",
  "iroko",
  "islam",
  "iucca",
  "iurta",
  "jabot",
  "jaleo",
  "jeans",
  "jihad",
  "joule",
  "jumbo",
  "kajal",
  "kamut",
  "kaone",
  "karma",
  "kasak",
  "kasba",
  "kazoo",
  "kebab",
  "kefir",
  "kendo",
  "khmer",
  "kilim",
  "koine",
  "kraal",
  "krill",
  "kulak",
  "kumys",
  "kuros",
  "kylix",
  "kyrie",
  "labbo",
  "labio",
  "labro",
  "lacco",
  "ladar",
  "lagna",
  "laico",
  "lamia",
  "lampa",
  "lanca",
  "landa",
  "langa",
  "lapin",
  "lapis",
  "lappa",
  "largo",
  "larva",
  "lasca",
  "lasco",
  "laser",
  "lassa",
  "lasso",
  "lasta",
  "latta",
  "lauda",
  "laude",
  "laura",
  "lauro",
  "lazzo",
  "lecco",
  "leena",
  "legge",
  "legna",
  "lella",
  "lemmo",
  "lemna",
  "lenee",
  "leneo",
  "lente",
  "lenti",
  "lesso",
  "letro",
  "letta",
  "leudo",
  "leuto",
  "lezio",
  "lezzo",
  "liana",
  "libra",
  "libro",
  "licet",
  "licio",
  "lidar",
  "lidio",
  "ligia",
  "lilla",
  "limio",
  "limma",
  "lince",
  "linea",
  "lione",
  "lippa",
  "lissa",
  "litio",
  "litro",
  "lituo",
  "lizza",
  "llano",
  "locco",
  "locus",
  "loden",
  "loffa",
  "lofio",
  "logos",
  "loico",
  "lokum",
  "lolla",
  "lombo",
  "lompo",
  "lonza",
  "loppa",
  "loran",
  "lordo",
  "losca",
  "lucco",
  "lucia",
  "lucro",
  "ludro",
  "luffa",
  "luigi",
  "lulla",
  "lumen",
  "lumia",
  "lunga",
  "luogo",
  "lupus",
  "lurex",
  "lutta",
  "lycra",
  "macao",
  "macca",
  "macco",
  "macea",
  "macho",
  "macia",
  "macis",
  "macro",
  "madia",
  "magio",
  "magma",
  "magra",
  "magro",
  "mahdi",
  "malga",
  "malia",
  "malva",
  "mammo",
  "manca",
  "manco",
  "manso",
  "manta",
  "manul",
  "manza",
  "maona",
  "maori",
  "marca",
  "marga",
  "marna",
  "marra",
  "marsa",
  "marso",
  "marza",
  "marzo",
  "masai",
  "masca",
  "maser",
  "masut",
  "matta",
  "matto",
  "mauro",
  "mauve",
  "meato",
  "mecca",
  "media",
  "medio",
  "melee",
  "meloe",
  "menda",
  "mendo",
  "mente",
  "mento",
  "meolo",
  "merca",
  "merce",
  "merco",
  "mergo",
  "meria",
  "merla",
  "messo",
  "metal",
  "meteo",
  "mezza",
  "miasi",
  "micca",
  "migma",
  "miler",
  "milia",
  "milio",
  "mille",
  "mimmo",
  "minio",
  "mista",
  "misto",
  "mitra",
  "mixer",
  "modio",
  "modem",
  "mogol",
  "moina",
  "moira",
  "moloc",
  "molva",
  "mommo",
  "monna",
  "monsu",
  "monta",
  "morbo",
  "moria",
  "morse",
  "morto",
  "morva",
  "mosca",
  "mosco",
  "mossa",
  "motta",
  "mouse",
  "mozza",
  "mufti",
  "mulso",
  "muone",
  "muria",
  "murra",
  "musco",
  "museo",
  "musli",
  "musme",
  "mutua",
  "nabuk",
  "nadir",
  "nagra",
  "naibi",
  "nandu",
  "nappa",
  "nappo",
  "narco",
  "nardo",
  "nasco",
  "nashi",
  "naspo",
  "nassa",
  "nasua",
  "natta",
  "nauta",
  "negro",
  "negus",
  "nenia",
  "neper",
  "nesci",
  "nesto",
  "netto",
  "neuma",
  "nicol",
  "nievo",
  "niffo",
  "nimbo",
  "ninna",
  "nitro",
  "nobel",
  "noema",
  "noesi",
  "nomea",
  "nonio",
  "noria",
  "norna",
  "norte",
  "novio",
  "nulla",
  "nummo",
  "nuoto",
  "nuovo",
  "obelo",
  "obito",
  "ocimo",
  "ocrea",
  "odeon",
  "oecio",
  "ofidi",
  "ofite",
  "ofiti",
  "oidio",
  "okapi",
  "olere",
  "olire",
  "olivo",
  "olmio",
  "olona",
  "olore",
  "omaro",
  "omaso",
  "omega",
  "omino",
  "omone",
  "oncia",
  "onice",
  "onire",
  "onlus",
  "onore",
  "opera",
  "orcio",
  "orgia",
  "orina",
  "orlon",
  "osmio",
  "ostio",
  "otite",
  "ovaio",
  "ovale",
  "ovato",
  "ovino",
  "ovolo",
  "ozena",
  "quark",
  "quota",
  "pacca",
  "padda",
  "pagro",
  "paino",
  "paisa",
  "palea",
  "paleo",
  "palpo",
  "palto",
  "pampa",
  "panel",
  "panne",
  "panno",
  "panza",
  "paolo",
  "paone",
  "papas",
  "pappo",
  "papua",
  "parca",
  "pardo",
  "pareo",
  "paria",
  "parka",
  "parma",
  "pasca",
  "pasco",
  "passi",
  "pasto",
  "patio",
  "patre",
  "peara",
  "peata",
  "pecan",
  "pecca",
  "pecia",
  "pelle",
  "pelta",
  "pence",
  "penso",
  "peota",
  "peplo",
  "pepsi",
  "perca",
  "persa",
  "perso",
  "pesco",
  "pesta",
  "petra",
  "pezza",
  "piada",
  "piana",
  "pieno",
  "pieta",
  "pieve",
  "pinot",
  "pinza",
  "piolo",
  "pirla",
  "pivot",
  "pixel",
  "plaga",
  "plaid",
  "plico",
  "ploro",
  "pocce",
  "polio",
  "polka",
  "polla",
  "polpa",
  "pomfo",
  "ponce",
  "pongo",
  "posca",
  "poste",
  "prece",
  "pozzo",
  "primo",
  "prima",
  "prive",
  "prode",
  "promo",
  "proto",
  "psoas",
  "pugio",
  "pugna",
  "pulce",
  "punch",
  "purea",
  "puzzo",
  "radon",
  "ragia",
  "rally",
  "rango",
  "raspa",
  "rateo",
  "razzo",
  "rebus",
  "regia",
  "reita",
  "relax",
  "renio",
  "retro",
  "ribes",
  "rocco",
  "rodeo",
  "rodio",
  "ronco",
  "ronca",
  "rosso",
  "rotto",
  "round",
  "ruffa",
  "rupia",
  "russo",
  "sabba",
  "sabeo",
  "sabir",
  "sabot",
  "sabra",
  "sacca",
  "sacro",
  "sagro",
  "sahib",
  "saiga",
  "saime",
  "salce",
  "salda",
  "saldo",
  "salmi",
  "salpa",
  "salsa",
  "salso",
  "salve",
  "salvo",
  "sambo",
  "sanna",
  "santo",
  "sapio",
  "sardo",
  "sarin",
  "saros",
  "sarto",
  "sartu",
  "satin",
  "sauna",
  "sauro",
  "saute",
  "savio",
  "sbafo",
  "scafa",
  "scana",
  "scapo",
  "scaro",
  "scart",
  "sceda",
  "scelo",
  "scemo",
  "scesa",
  "sceva",
  "schei",
  "schwa",
  "scolo",
  "scopo",
  "scoop",
  "score",
  "scoto",
  "scovo",
  "scudo",
  "scure",
  "scuro",
  "scuto",
  "sdire",
  "secca",
  "secco",
  "sedio",
  "selce",
  "selva",
  "semel",
  "senio",
  "sepoy",
  "sepsi",
  "serbo",
  "serge",
  "serie",
  "serir",
  "sermo",
  "serpa",
  "serto",
  "sesia",
  "sessa",
  "sesta",
  "sesto",
  "setta",
  "sette",
  "setto",
  "sfare",
  "sfero",
  "sfogo",
  "sforo",
  "sfumo",
  "sghei",
  "shoah",
  "shock",
  "siclo",
  "sigma",
  "silfo",
  "sillo",
  "silos",
  "simun",
  "sinti",
  "sirma",
  "sirte",
  "sitar",
  "sizio",
  "sizza",
  "skate",
  "skiff",
  "slang",
  "slavo",
  "slebo",
  "sloop",
  "smash",
  "snodo",
  "soave",
  "socco",
  "solco",
  "solea",
  "solfa",
  "solfo",
  "somma",
  "sommo",
  "sonar",
  "sonda",
  "sonio",
  "sonno",
  "sopra",
  "sorba",
  "sorbo",
  "sorca",
  "sordo",
  "sorgo",
  "sorra",
  "sorso",
  "sorta",
  "sorte",
  "sosia",
  "sosta",
  "sotto",
  "sozio",
  "spada",
  "spago",
  "spahi",
  "sparo",
  "spasa",
  "spata",
  "spato",
  "speck",
  "speco",
  "speme",
  "spera",
  "spesa",
  "spica",
  "spiga",
  "spigo",
  "spina",
  "spino",
  "spira",
  "spiro",
  "spola",
  "spora",
  "sport",
  "sposa",
  "sposo",
  "spray",
  "sprue",
  "spuma",
  "sputo",
  "squaw",
  "staff",
  "stage",
  "staio",
  "stame",
  "stand",
  "stare",
  "stasi",
  "stato",
  "stele",
  "stelo",
  "stero",
  "stesa",
  "steso",
  "stico",
  "stile",
  "stima",
  "stipe",
  "stipo",
  "stira",
  "stiro",
  "stiva",
  "stock",
  "stola",
  "stoma",
  "stria",
  "strip",
  "stufa",
  "stuka",
  "stupa",
  "stura",
  "succo",
  "sucre",
  "suede",
  "sugna",
  "suidi",
  "suino",
  "suite",
  "sulky",
  "sulla",
  "summa",
  "sunna",
  "sunto",
  "suolo",
  "suono",
  "super",
  "surra",
  "sushi",
  "sussi",
  "susta",
  "sutra",
  "svago",
  "svaso",
  "svevo",
  "svolo",
  "swing",
  "talea",
  "tanfo",
  "tango",
  "targa",
  "tarso",
  "tecno",
  "tenia",
  "tergo",
  "terme",
  "tesla",
  "testa",
  "teste",
  "tiara",
  "tilde",
  "tinca",
  "toast",
  "tocai",
  "tolda",
  "tondo",
  "toner",
  "torio",
  "torma",
  "torso",
  "trace",
  "trago",
  "tribu",
  "troia",
  "trono",
  "tropo",
  "trota",
  "truca",
  "tuffo",
  "tulio",
  "tulle",
  "tupla",
  "turba",
  "turbo",
  "turco",
  "turma",
  "tutto",
  "twist",
  "ubbia",
  "udire",
  "ulano",
  "ultra",
  "umato",
  "umbro",
  "umido",
  "unire",
  "unita",
  "urano",
  "urlio",
  "usare",
  "usato",
  "utero",
  "vampo",
  "vanni",
  "vario",
  "varva",
  "vasto",
  "vedda",
  "vegan",
  "velia",
  "velle",
  "velma",
  "venti",
  "vepre",
  "verde",
  "verga",
  "verla",
  "verna",
  "verno",
  "verso",
  "verta",
  "verve",
  "verza",
  "veste",
  "viado",
  "viero",
  "villo",
  "vilta",
  "vinco",
  "vinea",
  "violo",
  "virga",
  "virgo",
  "virtu",
  "virus",
  "visir",
  "visus",
  "vitta",
  "voile",
  "volgo",
  "volta",
  "volto",
  "volva",
  "water",
  "winch",
  "xenon",
  "yacht",
  "zabra",
  "zabro",
  "zaffo",
  "zaina",
  "zambo",
  "zanca",
  "zanna",
  "zanza",
  "zatta",
  "zendo",
  "zenit",
  "zifra",
  "zillo",
  "zinna",
  "zippa",
  "zirbo",
  "zirla",
  "zirlo",
  "zloty",
  "zocco",
  "zompo",
  "zonzo",
  "zoppo",
  "zozza",
  "zuavo",
  "zumba",
  "zurlo",
  "zurro",
];
